import LandingTestimonialsSection from './LandingTestimonialsSection';

export default LandingTestimonialsSection;
